import { render } from "./GaleriaPage.vue?vue&type=template&id=2d0df7d3&scoped=true"
import script from "./GaleriaPage.vue?vue&type=script&lang=js"
export * from "./GaleriaPage.vue?vue&type=script&lang=js"

import "./GaleriaPage.vue?vue&type=style&index=0&id=2d0df7d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0df7d3"]])

export default __exports__